import { action } from 'typesafe-actions';

import { AgriWebbSiteIntegrations } from 'types/models/agriwebb';
import { EnterpriseId } from 'types/models/enterprise';
import { WhiteLabelTitle } from 'types/models/white-label';

import AgriWebbActionType from './constants';
import { AgriWebbFarm } from './types';

/** Activate one enterprise */
export const activateAccount = (
  values: {
    enterpriseId: number;
    /** AgriWebb auth code */
    agriWebbCode: string;
    whiteLabel: WhiteLabelTitle;
  },
  onSuccess?: () => void,
  onError?: (errorMessage: string) => void
) =>
  action(AgriWebbActionType.ACTIVATE_ACCOUNT_REQUEST, {
    values,
    onSuccess,
    onError
  });

export const activateAccountSuccess = () =>
  action(AgriWebbActionType.ACTIVATE_ACCOUNT_SUCCESS);

export const activateAccountFailure = (message: string) =>
  action(
    AgriWebbActionType.ACTIVATE_ACCOUNT_FAILURE,
    { message },
    undefined,
    true
  );

export const editSiteFarmMappings = (
  values: { siteMapping: AgriWebbSiteIntegrations[]; enterpriseId: number },
  onSuccess?: () => void
) =>
  action(AgriWebbActionType.EDIT_SITE_FARM_MAPPINGS_REQUEST, {
    values,
    onSuccess
  });

export const editSiteFarmMappingsSuccess = () =>
  action(AgriWebbActionType.EDIT_SITE_FARM_MAPPINGS_SUCCESS);

export const editSiteFarmMappingsFailure = (message: string) =>
  action(
    AgriWebbActionType.EDIT_SITE_FARM_MAPPINGS_FAILURE,
    { message },
    undefined,
    true
  );

export const loadFarms = (
  enterpriseId: EnterpriseId,
  onSuccess: (farms: AgriWebbFarm[], siteMappings: AgriWebbSiteIntegrations[]) => void
) =>
  action(AgriWebbActionType.LOAD_FARMS_REQUEST, {
    enterpriseId,
    onSuccess
  });

export const loadFarmsSuccess = () =>
  action(AgriWebbActionType.LOAD_FARMS_SUCCESS);

export const loadFarmsFailure = (message: string) =>
  action(
    AgriWebbActionType.LOAD_FARMS_FAILURE,
    { message },
    undefined,
    true
  );
